import { useEffect, useState } from 'react'
import { Combobox } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/outline'
import LoadingOptions from './LoadingOptions'
import { isEmpty } from 'lodash'
import { SelectorIcon } from '@heroicons/react/solid'
import HelperText from './HelperText'
import { log } from '../../helpers/utils'
import { useLoading } from '../../context/LoadingProvider'
import { useRouter } from 'next/router'
import { orderNoForDesignFieldName } from '../../helpers/slug'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const ComboBoxComponent = ({ item, setParentValue, ...props }) => {
    const {
        // onChange: onChangeParent,
        errors,
        setValue,
        // register,
        shouldReset,
        // defaults,
        getValues,
        product,
    } = props

    const label = item.label || item.name

    const [selected, setSelected] = useState()
    const [query, setQuery] = useState('')
    // const [fontFamily, setFontFamily] = useState()

    const [options, setOptions] = useState()
    const [hasLoaded, setHasLoaded] = useState(false)

    const { setLoading } = useLoading()

    const router = useRouter()

    // function setFont(selected) {
    //     if (onChangeParent) onChangeParent(item.name, selected) // call parent onChange
    //     setFontFamily(findFont(selected))
    // }

    // const handleDefault = () => {
    //     const findDefault = defaults?.find(({ name }) => name === item.name)
    //     if (findDefault) {
    //         const defaultOption = item.options.find(
    //             (option) =>
    //                 matchStripString(findDefault.option) ===
    //                 matchStripString(option),
    //         )
    //         if (defaultOption) {
    //             // log('defaultOption', defaultOption)
    //             // log('sdd',setValue(item.name, defaultOption))
    //             // handleSelect(defaultOption)
    //         }
    //     }
    // }

    const handleSelect = (value) => {
        setValue(item.name, value)
        setSelected(value)
        setParentValue(value)
        // if (value) {
        //     setFont(value)
        // }
    }

    useEffect(() => {
        setSelected(null)
        setValue(item.name, null)
    }, [shouldReset, item.options])

    const filterOptions = (options) => {
        if (!item.name?.includes(orderNoForDesignFieldName)) return options
        const slugIncludesPostcard =
            product?.slug &&
            String(product.slug).toLowerCase().includes('postcard')
        if (slugIncludesPostcard) return options
        if (!product?.name) return options
        return options.filter((option) => {
            const match = option.match(/\[([^\]]+)\]/)
            const extractedProductName = match ? match[1].trim() : ''
            return String(extractedProductName).startsWith(product.name)
        })
    }

    const handleLoadOptions = async () => {
        if (item?.shouldLoadOptions && item.loadFunction) {
            const options = await item.loadFunction({ product })
            const loadedOptions = filterOptions(options)
            setOptions(loadedOptions)
            setHasLoaded(true)
        }
    }

    const filteredOptions =
        query === ''
            ? options
            : options.filter((person) => {
                  return person.toLowerCase().includes(query.toLowerCase())
              })

    useEffect(() => {
        handleLoadOptions()
        return () => {
            setOptions(item.options)
            setHasLoaded(true)
        }
    }, [item.shouldLoadOptions])

    useEffect(() => {
        setOptions(item.options)
    }, [item.options])

    // useEffect(() => {
    //     handleDefault()
    // }, [])

    useEffect(() => {
        if (isEmpty(getValues(item.name))) {
            setSelected(null)
            if (props.reloadShowFields) {
                props.reloadShowFields()
            }
        }
        return () => {
            props?.reloadShowFields && props.reloadShowFields()
        }
    }, [getValues()])

    const freshReload = async () => {
        try {
            setLoading(true)
            const options = await item.loadFreshFunction({ product })
            setOptions(filterOptions(options))
        } catch (e) {
            log(e)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (router.query?.template) {
            const template = { url: router.query?.template }
            handleSelect(template)
        }
    }, [router.query])

    if (item?.shouldLoadOptions && item?.loadFunction && !hasLoaded) {
        return <LoadingOptions />
    }
    return (
        <>
            <Combobox as="div" value={selected} onChange={handleSelect}>
                <Combobox.Label className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.04em] text-gray-500">
                    {label}
                </Combobox.Label>
                <div className="relative mb-[11px]">
                    <Combobox.Input
                        className={classNames(
                            errors?.[item.name]
                                ? 'border-red-500'
                                : 'border-[#E1DACE]',
                            'w-full rounded-[10px] border bg-white py-[13px] pl-3.5 pr-[42px] text-[14.5px] font-medium text-[#1A1D23] shadow-none transition-all duration-150 placeholder:text-gray-400 focus:border-[#F28230] focus:outline-none focus:ring-4 focus:ring-[#F28230]/15',
                        )}
                        onChange={(event) => setQuery(event.target.value)}
                        displayValue={(person) => person}
                        placeholder="Search by order #"
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3.5">
                        {/* {selected && (
                        <button onClick={() => handleSelect(null)}>
                            <XIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </button>
                    )} */}
                        <Combobox.Button className="inline-flex items-center justify-center">
                            <SelectorIcon
                                className="h-4 w-4 text-gray-500"
                                aria-hidden="true"
                            />
                        </Combobox.Button>
                    </div>

                    {filteredOptions.length > 0 && (
                        <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-[10px] bg-white py-1 text-base shadow-lg ring-1 ring-[#E1DACE] focus:outline-none sm:text-sm">
                            {filteredOptions.map((person) => (
                                <Combobox.Option
                                    key={person}
                                    value={person}
                                    className={({ active }) =>
                                        classNames(
                                            'relative cursor-default select-none py-2.5 pl-3.5 pr-9 text-[14px]',
                                            active
                                                ? 'bg-[#FDF4EC] text-[#1A1D23]'
                                                : 'text-[#1A1D23]',
                                        )
                                    }>
                                    {({ active, selected }) => (
                                        <>
                                            <span
                                                className={classNames(
                                                    'block truncate',
                                                    selected && 'font-semibold',
                                                )}>
                                                {person}
                                            </span>

                                            {(selected || active) && (
                                                <span
                                                    className={classNames(
                                                        'absolute inset-y-0 right-0 flex items-center pr-4',
                                                        'text-[#ED5C2F]',
                                                    )}>
                                                    <CheckIcon
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                    />
                                                </span>
                                            )}
                                        </>
                                    )}
                                </Combobox.Option>
                            ))}
                        </Combobox.Options>
                    )}
                </div>
            </Combobox>
            {item?.description && (
                <div className="mt-2 flex items-center justify-between gap-3">
                    <div className="min-w-0 flex-1 text-[12.5px] leading-[1.55] text-gray-500">
                        {item?.description}
                    </div>
                    <button
                        type="button"
                        aria-label="Refresh previous orders"
                        title="Refresh previous orders"
                        className="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#EFE9E0] text-[#1A1D23] transition-[transform,background-color] duration-150 hover:bg-[#E7E0D5] active:translate-y-[1px] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E7E0D5] focus-visible:ring-offset-2"
                        onClick={freshReload}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-[16px] w-[16px]"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M4 4v5h.582m14.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-14.357-2m14.357 2H15"
                            />
                        </svg>
                    </button>
                </div>
            )}

            {item?.helpersObject && item?.helpersObject?.[selected] && (
                <HelperText>{item?.helpersObject[selected]}</HelperText>
            )}
        </>
    )
}

export { ComboBoxComponent }
